$(function () {
  // Show all cities

  $("#js-show-cities").on("click", function () {
    $(".df-cities__item").removeClass("d-none");
    $(this).addClass("d-none");
    $("#js-hide-cities").removeClass("d-none");
  });

  // Hide cities

  $("#js-hide-cities").on("click", function () {
    $(".df-cities__item--additional").addClass("d-none");
    $(this).addClass("d-none");
    $("#js-show-cities").removeClass("d-none");
  });

  // Toggle affilates by city

  function filterAffilates(city) {
    $(".df-places__list__item").addClass("d-none");
    $(".df-places__list__item[data-city='" + city + "']").removeClass("d-none");

    $(".df-places__select[name='place'] option").addClass("d-none");
    $(".df-places__select[name='place'] option[data-city='" + city + "']").removeClass("d-none");
    $(".df-places__select[name='place'] option[value='0']").removeClass("d-none");
    $(".df-places__select[name='place']").val("0");
    $('.df-places__list').scrollTop(0);

    if ($(".df-places__list__item[data-city='" + city + "']").length) {
      googleMap.setCenter({
        lat: Number(
          $(".df-places__list__item[data-city='" + city + "']")
            .first()
            .find(".df-places__list__item__affiliates__item")
            .first()
            .data("lat")
        ),
        lng: Number(
          $(".df-places__list__item[data-city='" + city + "']")
            .first()
            .find(".df-places__list__item__affiliates__item")
            .first()
            .data("lng")
        ),
      });
    }
  }

  // Select city

  $(".df-cities__item").on("click", function () {
    if (!$(this).hasClass("active")) {
      $(".df-cities__item").removeClass("active");
      $(this).addClass("active");

      $("#js-cities").val($(this).data("city"));

      filterAffilates($(this).data("city"));
    }
  });

  $("#js-cities").on("change", function () {
    $(".df-cities__item").removeClass("active");
    $(".df-cities__item[data-city='" + $(this).val() + "']").addClass("active");

    filterAffilates($(this).val());
  });

  $("#js-places").on("change", function () {
    const $option = $(this).find("option:selected");
    if ($option.attr("value") !== "0") {
      const $affiliate = $(".df-places__list__item__affiliates__item[data-id='" + $option.attr("value") + "']");
      $('.df-places__list').animate({
        scrollTop: $affiliate.get(0).offsetTop
      }, 400);
      $affiliate.trigger("click");
    }
  });

  $(".df-places__list__item__affiliates__item").on("click", function () {
    $(".df-places__list__item__affiliates__item").removeClass("active");
    $(this).addClass("active");

    const marker = googleMarkers.find(
      (marker) =>
        marker.getPosition().lat() === Number($(this).data("lat")) &&
        marker.getPosition().lng() === Number($(this).data("lng"))
    );

    new google.maps.event.trigger(marker, "click");
  });
});
